import { useEffect, useRef } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useLoadingData = (data: any) => {
  const loadingData = useRef(data);

  useEffect(() => {
    if (data?.length) {
      loadingData.current = data;
    }
  }, [data]);

  return loadingData.current;
};
